import React, { Component } from 'react'
import Dialog from "@material-ui/core/Dialog";
import FileUploader from "../../common/fileUploader/fileUploader.js";
import FileDownload from "../../common/fileDownload/fileDownload.js";
export default class CreditAnchor extends Component {
    state = {
		open: false
	};

	handleClickOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};
    render() {
        let restrictmailids = JSON.parse(localStorage.getItem("user"));
        let jumbotailUser = restrictmailids.userProfile.loginId.split('@');
        let tenant_Id =restrictmailids.userProfile.tenantId;

		return (
			<div style={{ display: 'flow-root',padding:'30px' }}>
				{jumbotailUser[1]=='jumbotail.com'&& tenant_Id=="TENANT-135108" ?(<button onClick={this.handleClickOpen} className="btn btn-jt-ops pull-right">
					+ Create New Credit Anchor
				</button>):''}

				<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="responsive-dialog-title" maxWidth="lg" classes={{ paperWidthSm: 'wider-dialoge' }}>
					<div>
						<div style={{ padding: "20px" }}>
							<div className="row">
								<div className="col-md-12">
									<div className="pull-right" onClick={this.handleClose} style={{ fontSize: "22px", cursor: "pointer" }}>
										<i className="fas fa-times" />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6">
									<div className="ingestionTitle">Create Anchor</div>
									<div className="formattor">
										<FileDownload title={"Download Format"} url="api/credit/gateway/template/ingest/anchor_create" />
									</div>
									<FileUploader url="api/credit/gateway/ingest/credit_anchor/create" />
								</div>
								<div className="col-md-6">
									<div className="ingestionTitle">Update Anchor Status</div>
									<div className="formattor">
										<FileDownload title={"Download Format"} url="api/credit/gateway/template/ingest/update_anchor_status" />
									</div>
									<FileUploader url="api/credit/gateway/ingest/credit_anchor/update_status" />
								</div>
								
							</div>
						</div>
					</div>
				</Dialog>
			</div>
		);
	
    }
}



// WEBPACK FOOTER //
// ./src/screens/CreditAnchor/CreditAnchor.js